module.exports = __webpack_public_path__ + "img/guanfangshouquan-tuya.0613447e.png";